import { render, staticRenderFns } from "./AIChatWidgetAbHeroPicker.vue?vue&type=template&id=0bec5eec&scoped=true"
import script from "./AIChatWidgetAbHeroPicker.vue?vue&type=script&lang=js"
export * from "./AIChatWidgetAbHeroPicker.vue?vue&type=script&lang=js"
import style0 from "./AIChatWidgetAbHeroPicker.vue?vue&type=style&index=0&id=0bec5eec&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bec5eec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bec5eec')) {
      api.createRecord('0bec5eec', component.options)
    } else {
      api.reload('0bec5eec', component.options)
    }
    module.hot.accept("./AIChatWidgetAbHeroPicker.vue?vue&type=template&id=0bec5eec&scoped=true", function () {
      api.rerender('0bec5eec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/EditorControl/components/AIChat/widgets/AIChatWidgetAbHeroPicker.vue"
export default component.exports